import { Alert, AlertTitle, Button, Typography } from "@mui/material";
import { visuallyHidden } from "@mui/utils";
import { ReactNode } from "react";
import { ApiError } from "../api/errors/ApiError";
import { keyToErrorMessage } from "../api/errors/keyToErrorMessage";

interface QueryErrorProps {
  message?: ReactNode;
  unknownMessage?: string;
  ariaUnknownMessage?: string;
  error: unknown;
  refetch: () => void;
}

const QueryError = ({
  error,
  refetch,
  message,
  ariaUnknownMessage,
  unknownMessage = "Ups coś poszło nie tak!",
}: QueryErrorProps) => {
  const refetchButton = (
    <Button
      onClick={() => refetch()}
      sx={{ px: 3 }}
      color="inherit"
      variant="text"
      size="small"
    >
      Spróbuj ponownie
    </Button>
  );
  if (error instanceof ApiError) {
    return (
      <Alert data-testid="error" severity="error" action={refetchButton}>
        {message && <AlertTitle>{message}</AlertTitle>}
        <Typography>
          Wystąpił błąd: {keyToErrorMessage(error.backendError.errorCode)}
        </Typography>
      </Alert>
    );
  }

  console.error("Unknown error", error);

  return (
    <Alert data-testid="error" severity="error" action={refetchButton}>
      {message && <AlertTitle>{message}</AlertTitle>}
      <Typography aria-hidden={true}>{unknownMessage}</Typography>
      <Typography sx={visuallyHidden}>{ariaUnknownMessage}</Typography>
    </Alert>
  );
};

export default QueryError;
